var render = function () {
  var _vm$notification$titl;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "NotificationList",
      "extra-items": _vm.isReadOnly ? [{
        text: (_vm$notification$titl = _vm.notification.title) !== null && _vm$notification$titl !== void 0 ? _vm$notification$titl : ''
      }] : ['新增通知']
    }
  })], 1)]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("通知名稱：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.notification.title,
      expression: "notification.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "readonly": _vm.isReadOnly
    },
    domProps: {
      "value": _vm.notification.title
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notification, "title", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group form-row align-items-center"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("分店：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_vm.isReadOnly ? _c('div', [_c('BranchTable', {
    attrs: {
      "branches": _vm.notification.branches
    }
  })], 1) : _vm.isEditing ? _c('b-form-group', [_c('b-form-radio-group', {
    model: {
      value: _vm.chooseBranch,
      callback: function callback($$v) {
        _vm.chooseBranch = $$v;
      },
      expression: "chooseBranch"
    }
  }, [_c('b-form-radio', {
    staticClass: "w-100",
    attrs: {
      "value": false
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-4 flex-shrink-0"
  }, [_vm._v("維持不變")]), _c('BranchTable', {
    staticClass: "flex-shrink-0 flex-grow",
    attrs: {
      "branches": _vm.notification.branches
    }
  })], 1)]), _c('b-form-radio', {
    attrs: {
      "value": true
    }
  }, [_vm._v("重新選取")])], 1)], 1) : _vm._e(), !_vm.isReadOnly && _vm.chooseBranch ? _c('b-form-group', [_c('b-form-radio-group', {
    model: {
      value: _vm.branchGroup,
      callback: function callback($$v) {
        _vm.branchGroup = $$v;
      },
      expression: "branchGroup"
    }
  }, [_vm.$permissions.has(_vm.$permissions.consts.NOTIFICATION_MODIFY_CHANGE_BRANCH) ? _c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_GROUP.ALL
    }
  }, [_vm._v("全部分店")]) : _vm._e(), _c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_GROUP.ONE
    }
  }, [_c('b-form-select', {
    attrs: {
      "size": "sm",
      "disabled": _vm.branchGroup !== _vm.BRANCH_GROUP.ONE
    },
    model: {
      value: _vm.oneBranch,
      callback: function callback($$v) {
        _vm.oneBranch = $$v;
      },
      expression: "oneBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v("選擇分店")]), _vm._l(_vm.branchOptions, function (branch) {
    return _c('b-form-select-option', {
      key: branch.value,
      attrs: {
        "value": branch.value
      }
    }, [_vm._v(_vm._s(branch.text))]);
  })], 2)], 1), _vm.$permissions.has(_vm.$permissions.consts.NOTIFICATION_MODIFY_CHANGE_BRANCH) ? _c('b-form-radio', {
    attrs: {
      "value": _vm.BRANCH_GROUP.EXCEL
    }
  }, [_c('div', {
    staticClass: "form-group d-inline-flex align-items-center"
  }, [_c('label', {
    staticClass: "flex-shrink-0 mr-2 mb-0"
  }, [_vm._v("上傳分店")]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "input": _vm.uploadBranches
    }
  })], 1)]) : _vm._e(), _vm.$permissions.has(_vm.$permissions.consts.NOTIFICATION_MODIFY_CHANGE_BRANCH) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/branch_list.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")]) : _vm._e()], 1)], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("發送時間：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.notification.date,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "date", $$v);
      },
      expression: "notification.date"
    }
  })], 1), _c('div', {
    staticClass: "col-sm-6 timepicker"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": "form-control",
      "hide-clear-button": "",
      "disabled": _vm.isReadOnly,
      "minute-interval": 10
    },
    model: {
      value: _vm.notification.time,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "time", $$v);
      },
      expression: "notification.time"
    }
  })], 1)])])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("通知內容")]), _c('TrixEditor', {
    attrs: {
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.notification.content,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "content", $$v);
      },
      expression: "notification.content"
    }
  })], 1), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("通知URL：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.notification.related_url,
      expression: "notification.related_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    domProps: {
      "value": _vm.notification.related_url
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.notification, "related_url", $event.target.value);
      }
    }
  })])]), _c('b-form-checkbox', {
    attrs: {
      "value": "important",
      "unchecked-value": "info",
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.notification.notify_type,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "notify_type", $$v);
      },
      expression: "notification.notify_type"
    }
  }, [_vm._v(" 標註為重要通知 ")]), _c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-outline-danger",
    on: {
      "click": _vm.goToList
    }
  }, [_vm._v(" 返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm.isEditing ? _c('span', [_vm._v("確認儲存")]) : _c('span', [_vm._v("確認新增")])]) : _vm._e()], 1)], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }